import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-question-block',
  templateUrl: './question-block.component.html',
  styleUrls: ['./question-block.component.css'],
})
export class QuestionBlockComponent {
  @Input() missingQuestionUuids: string[] = [];
  @Input() isMissing = false;
  @Output() answered = new EventEmitter<string>();
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue?:
      | string
      | { multiple: string; confidence: string }
      | { choice: string; other?: string };
    answerValues?: string[];
    otherValue?: string | Record<string, string>;
  }>();

  handleAnswerSelection(event: {
    questionUuid: string;
    answerValue?:
      | string
      | { multiple: string; confidence: string }
      | { choice: string; other?: string };
    answerValues?: string[];
    otherValue?: string | Record<string, string>;
  }): void {
    this.answerSelected.emit(event);
    this.answered.emit(event.questionUuid);
  }
}
